import React from 'react';
import { Formik, Field } from 'formik';
import { noop } from 'lodash';

import styles from './userBadgesPageStyles';

import SingleCheckboxField from 'buyside/components/presentation/Form/Field/SingleCheckboxField/singleCheckboxField';

const BadgeDisplayOnProfileCheckbox = ({ initialValues, updateBadgeVisibility }) => (
  <Formik initialValues={initialValues} onSubmit={noop}>
    {({ values }) => (
      <div>
        <Field
          component={SingleCheckboxField}
          customStyles={styles}
          label="Display On Profile"
          name="visible"
          onClick={() => {
            updateBadgeVisibility({
              ...values,
              badgeCollectionRelationshipId: values.badgeCollectionRelationshipId,
              visible: !values.visible
            });
          }}
          overrideStyles={styles}
          value={values.visible}
        />
      </div>
    )}
  </Formik>
);

export default BadgeDisplayOnProfileCheckbox;
